export const MobileStepStatement = {
  /**
   * @type {OrderFormBySteps}
   */
  parent: null,

  /**
   * @type {NodeListOf<Node>}
   */
  navList: null,

  init() {
    this.navList = this.parent.order.parentElement
      .parentElement.querySelectorAll('.checkout-nav-list [data-step]');
    this
      .listenNavClick()
      .cloneClassesFromParentSteps(this.navList)
      .listenParentUpdate();
    return this;
  },

  listenParentUpdate() {
    this.parent.order.addEventListener('Order:update', (e) => {
      setTimeout(() => {
        this.cloneClassesFromParentSteps(this.navList);
      }, 0);
    });
    return this;
  },

  cloneClassesFromParentSteps(tabs) {
    const activeParent = this.parent.order.querySelector('.active');
    const activeParentIndex = [...this.parent.order.children].indexOf(activeParent);
    for (let i = 0; i < this.parent.TABS.length; i += 1) {
      this
        .toggleClass(this.parent.TABS[i], tabs[i], 'invalid')
        .toggleClass(this.parent.TABS[i], tabs[i], 'valid')
        .toggleClass(this.parent.TABS[i], tabs[i], 'skip')
        .toggleClass(this.parent.TABS[i], tabs[i], 'disabled'); // TODO: Need cycle
    }
    document.querySelector('.checkout-nav-list .active').classList.remove('active');
    this.navList[activeParentIndex].classList.add('active');
    return this;
  },

  toggleClass(parent, clone, param) {
    if (parent.element.classList.contains(param)) {
      clone.classList.add(param);
    } else {
      clone.classList.remove(param);
    }
    return this;
  },

  listenNavClick() {
    return this;
  },

  setParent(parentClass) {
    this.parent = parentClass;
    return this;
  },
};
